export const API_REQUEST_STATUSES = {
  Ok: "Ok"
};
